import { Box, Grid, Typography } from '@material-ui/core';
import { makeStyles, Theme } from '@material-ui/core/styles';
import { Button } from '@roc/ui';
import { observer } from 'mobx-react';
import { WireInstructionsStore } from '../stores/wireInstructionsStore';

const useStyles = makeStyles((theme: Theme) => ({
  noticeBox: {
    maxWidth: 1000,
    margin: 'auto',
    padding: theme.spacing(5),
    backgroundColor: '#FFF8E1',
    border: '1px solid #F0C000',
    borderLeft: '6px solid #F0C000',
    borderRadius: theme.spacing(1),
  },
  heading: {
    fontWeight: 700,
    marginBottom: theme.spacing(3),
    color: '#8A6D00',
  },
  paragraph: {
    fontSize: '0.85rem',
    lineHeight: 1.7,
    marginBottom: theme.spacing(2),
    color: theme.palette.text.primary,
  },
  button: {
    fontWeight: 'normal',
    padding: theme.spacing(2, 8),
  },
}));

interface Props {
  store: WireInstructionsStore;
  onContinue: () => void;
}

export const WireFraudNoticeStep = observer(({ onContinue }: Props) => {
  const classes = useStyles();

  return (
    <>
      <Box className={classes.noticeBox}>
        <Typography variant="h6" className={classes.heading}>
          ⚠ IMPORTANT — WIRE FRAUD NOTICE TO TITLE COMPANY
        </Typography>

        <Typography className={classes.paragraph}>
          Wire fraud targeting real estate closings is pervasive. Before
          transmitting wire instructions to any party, the Title Company
          represents and warrants that it has verified this form was received
          directly from the Lender identified above through an authenticated,
          secure channel.
        </Typography>

        <Typography className={classes.paragraph}>
          Lender will never communicate changes to wire instructions solely by
          email. If the Title Company receives any request to modify wire
          instructions, it must contact Lender directly using the phone number
          on this form — independently verified — before acting on any such
          request.
        </Typography>

        <Typography className={classes.paragraph}>
          Lender assumes no liability for loan proceeds disbursed to an account
          not verified in accordance with these instructions and the procedures
          set forth herein.
        </Typography>
      </Box>

      <Grid container style={{ justifyContent: 'center' }}>
        <Button
          testId="continue"
          variant="contained"
          color="primary"
          className={classes.button}
          onClick={onContinue}
          style={{ marginTop: 24 }}
        >
          CONTINUE
        </Button>
      </Grid>
    </>
  );
});
